import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  valuationGoalSelect: 'Choose your valuation goal',
  valuationGoalIOwnProperty: 'Value a property I own',
  valuationGoalCheckPrice: 'Check a property’s value',
  valuationGoalSavedPortfolio: 'The result will be saved in',
  valuationGoalSavedPortfolioWhere: '(My Portfolio)',
  valuationGoalSavedMyValuations: 'The result will be saved in',
  valuationGoalSavedMyValuationsWhere: '(My Valuations)',
  locationTitle: 'Property Location',
  locationPlaceholder: 'Location',
  propertyDetailsEnter: 'Enter property details',
  propertyType: 'Property type',
  propertyView: 'View',
  propertyFinishing: 'Finishing type',
  propertyArea: 'Area (m²)',
  propertyAreaPlaceholder: 'Enter area',
  m2: 'm²',
  propertyRooms: 'Rooms',
  propertyRoomsPlaceholder: 'Rooms',
  enterNumber: 'Enter number',
  propertyBathrooms: 'Bathrooms',
  propertyBathroomsPlaceholder: 'Bathrooms',
  next: 'Next',
  back: 'Back',
  purchaseAddPrice: 'Property Purchase Price',
  purchaseAddPricePlaceholder: 'Enter purchased price',
  purchaseEnterDate: 'Purchase Date',
  monthAndYear: ' (month and year)',
  purchasePriceBasis:
    'The purchase price is the basis we use to calculate the expected investment return',
  purchaseCurrentEstimate:
    'Your current estimated price helps us review the tool’s calculations and compare them with your expectations',
  purchaseEnterEstimate: 'Your estimate of the property’s value',
  purchaseEnterEstimatePlaceholder: 'Enter estimated price',
  finalAnalyzing: 'Analyzing properties data',
  finalStep: 'Step',
  from: ' From ',
  finalCalculate: 'Calculate estimated value',
  valuations: 'Valuations',
  portfolio: 'My Portfolio',
  valuationEmptyTitle: 'No valuations yet',
  valuationEmptyDescription:
    'Add your first one to check price per meter in areas you care about.',
  addFirstValuation: 'Add your first valuation',
  addNewValuation: 'Add new valuation',
  portfolioEmptyTitle: 'No properties in your portfolio.',
  portfolioEmptyDescription:
    'Add your first one to track its value and expected return.',
  numberOfProperties: 'Number of properties',
  purchasePrice: 'Total portfolio',
  purchasePriceDescription:
    'This is the current value of your properties based on today’s market prices if they were sold now.',
  valuationPrice: 'Portfolio market value',
  valuationPriceDescription:
    'The value of the property portfolio is the original purchase cost at the time of acquisition.',
  valuationsIntro:
    'Track properties you previously evaluated and similar listings',
  estimatedPriceNow: 'Estimated price now',
  moreDetails: 'More details',
  propertyValuation: 'Property Valuation',
  lastUpdated: 'Last Updated: {{date}}',
  purchasePriceTooltipText:
    'The purchase price helps us calculate the expected return from selling',
  expectedValuationPriceTooltipText:
    'Your current estimated price helps us review the tool’s calculations and compare them with your expectations.',
  valuationReport: 'Valuation Report',
  pound: 'EGP',
  currentValuationSalePrice: 'Estimated Sale Price Now',
  addListing: 'Add Listing',
  currentValuationRentPrice: 'Estimated Rent Price Now',
  soon: 'Soon',
  confidenceRate: 'Accuracy',
  averagePricePerMeter: 'Average Price per Meter',
  ROI: 'ROI',
  YOY: 'YOY Growth',
  relatedListingTitle: 'Related Listings',
  YOYTooltipText:
    "It's a percentage change in the property price over the past 12 months",
  ROItooltipText:
    'Your current gain on this property compared to your buying price.',
  purchasePriceText: 'Purchase Price',
  purchasePriceInfoNameText:
    'The original price at which the property was purchased at the time of signing the contract.',
  valuationPriceText: 'Current Value',
  valuationPriceInfoNameText:
    'An estimated value of the property, calculated based on market data and indicators, with {{confidenceRate}}% accuracy.',
  returnOnInvestment: 'Return on Investment',
  returnOnInvestmentInfo:
    "A measure of the property's profitability, calculated by comparing the purchase price to its current estimated value.",
  returnOnInvestmentTitle: 'Return on Investment (ROI)',
  compareMarketValueTitle: 'Compare Market Value',
  marketAnalysisTitle: 'Market Insights',
  marketSampleSize: 'Market Sample Size',
  numberOfListingsAnalyzed: 'Number of listings analyzed',
  demandIndicator: 'Buyer Demand Level',
  demandIndicatorLabel: 'It indicates how popular buying is in the area.',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  priceIndex: 'Price Index',
  priceIndexTooltipLabel:
    'This index shows property price movement over the last 12 months.',
  yearlyChange: 'Yearly Price Change',
  purchasePriceRequired: 'Enter Purchase Price',
  purchaseDateRequired: 'Enter Date of Price',
  topSellersTitle: 'Top Real Estate Agencies',
  topSellersDescription:
    'Trusted real estate companies that can help you choose and buy the perfect apartment in {{location}}.',
  portfolioTitle: 'A complete view of your properties, and their value changes',
  estimationsTitle: 'Track the Price per meter in locations you’ve evaluated',
  marketAIAnalysis: 'Real-time market data analysis powered by AI',
  propertyInstantValuation: 'Instant estimate of your property’s value',
  trackDemandLevel: 'Track demand level in your interested locations',
  knowRealValue:
    'Know the real value of your property with the Property Valuation Tool',
  LUXURY: 'Luxury',
  SUPPER_LUXURY: 'Super Luxury',
  EXTRA_SUPER_LUXURY: 'Extra Super Luxury',
  SEMI_FINISHED: 'Semi Finished',
  UNFINISHED: 'Unfinished',
  NILE: 'Nile',
  GOLF: 'Golf',
  LAKE: 'Lake',
  PLAZA: 'Plaza',
  CLUB: 'Club',
  BACK: 'Back',
  GARDEN: 'Garden',
  POOL: 'Pool',
  SEAVIEW: 'Seaview',
  CORNER: 'Corner',
  SIDE_STREET: 'Side Street',
  MAIN_STREET: 'Main Street',
  OTHER: 'Other',
  noValuationResultsFound: 'Sorry..We don’t have enough data',
  noValuationResultsFoundDescription:
    'Please update your property details to get a reliable valuation',
  createAccount: 'Sign Up',
});
